import { render, staticRenderFns } from "./BackBtn.vue?vue&type=template&id=126bb268&scoped=true&"
import script from "./BackBtn.vue?vue&type=script&lang=ts&"
export * from "./BackBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126bb268",
  null
  
)

export default component.exports